import React, { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { iStore, iOrgUnit } from '~/domain/interfaces/models';
import { orgUnitProps } from '../index';

export interface createOrgUn {
  id: number;
  shortname?: string;
}

/**
 * Mapping of the appointment list data.
 *
 * @param Component component to connect.
 */
export function ConnectComponent<P>(
  Component: ComponentType<P & orgUnitProps>,
): React.FC<P> {
  const Render: React.FC<P> = ({ ...rest }) => {
    const { results } = useSelector((store: iStore) => store.orgUnit);
    /* eslint no-param-reassign: "error" */
    Component.defaultProps = {
      data: MapNewOrgUnitData(results),
      ...(rest as P),
    };
    return <Component {...(rest as P & orgUnitProps)} />;
  };

  return Render;
}

/**
 * component data mapper
 * @param appointment data.
 */
export const MapNewOrgUnitData = (
  orgUnit: iOrgUnit['results'],
): createOrgUn[] => {
  if (!orgUnit.length) return [];
  const data: createOrgUn[] = orgUnit.map(item => ({
    id: item.org.id,
    shortname: item.org.shortname,
  }));
  console.log('infos: ', data);

  return data;
};
